<template>
  <div id="app">
    <router-view/>
    <div class="tab-view" ref="tabView" :style="{'padding-bottom':isIphoneX?'0.67rem':''}">
      <div class="span-center f45" :class="tabIndex == index ? 'c24af08':''" v-for="(item, index) in tabsList"  @click="tabsChange(index)">
        <div class="iconfont h50" :class="item.class"></div>
        <div class="f23">{{item.text}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import "@/css/iconfont.css"
import '@/css/app.css'
import VueAudio from './components/VueAudio'

export default {
  name: 'App',
  data() {
    return {
      tabIndex: 0,
      isIphoneX:false,
      tabsList: [
        {
          class: "icon-zhuye",
          text: "主页",
          path: "/index"
        },
        {
          class: "icon-mulu",
          text: "目录",
          path: "/cata"
        },
        {
          class: "icon-fangdajing1",
          text: "搜索",
          path: "/search"
        },
        {
          class: "icon-iconfonticon5",
          text: "我的",
          path: "/personCenter"
        },
      ]
    };
  },
  methods:{
    tabsChange(index) {
      this.tabIndex = index;
      this.$router.push({
        path: this.tabsList[index].path
      });
    },
    changeActive($event){
      $event.currentTarget.className = $event.currentTarget.className +  " c24af08";
    },
    removeActive($event){
      $event.currentTarget.className = $event.currentTarget.className.replace("c24af08","");
    }
  }
}
</script>

<style>
  @media only screen and (device-width: 375px) and (device-height: 812px) and (-webkit-device-pixel-ratio: 3) {
    /*.header {*/
    /*padding-top: 44px;*/
    /*height: 88px;*/
    /*}*/
    .scroll-area {
      height: calc(100vh - 88px - 50px);
      overflow: auto;
      -webkit-overflow-scrolling: touch;
    }
  }
</style>



// WEBPACK FOOTER //
// src/App.vue